<div fxFlex="80" fxFlexOffset="10">
  <div class="toto">
    <div class="group-body">
      <h2 class="title-CVM">Group Element</h2>
      <div class="group-container">
        <mat-form-field class="search" appearance="fill">
          <mat-label>Filter</mat-label>
          <input matInput [formControl]="search" placeholder="Ex. ium" />
          @if (!searchValue) {
          <button mat-icon-button matSuffix>
            <mat-icon>search</mat-icon>
          </button>
          } @if (searchValue) {
          <button mat-icon-button matSuffix aria-label="Clear" (click)="clearSearch()">
            <mat-icon>close</mat-icon>
          </button>
          }
        </mat-form-field>
      </div>
    </div>
    @if (resultSearch.length !== 0) { @for (group of resultSearch; track group.id) {
    <div>
      <mic-app-group-element (deleteItemEvent)="deleteGroup($event)" [element]="group"></mic-app-group-element>
      <mat-divider class="divider"></mat-divider>
    </div>
    } } @else {
    <mic-empty-state icon="layers_clear" title="There is no Repository to display."> </mic-empty-state>
    }
  </div>
</div>
